// src/utils/manifestTrackingReportConfig.js

const API_ORIGIN = process.env.REACT_APP_API_URL;

export const CHECKS_IMAGE_BASE =
    process.env.REACT_APP_CHECKS_IMAGE_BASE
    || `${API_ORIGIN}/documents/file/vehicle-checks/`;

export const DEFAULT_STATES = ['COMPLETADO', 'EN_PROCESO'];
export const PAGE_SIZE = 25;

export const MANIFEST_STATUS_CONFIG = {
    CREADO:      { label: 'CREADO',      color: '#90a4ae', text: '#fff' },
    PLANIFICADO: { label: 'PLANIFICADO', color: '#ffb300', text: '#000' },
    EN_PROCESO:  { label: 'EN PROCESO',  color: '#4caf50', text: '#fff' },
    COMPLETADO:  { label: 'COMPLETADO',  color: '#1e88e5', text: '#fff' },
    CANCELADO:   { label: 'CANCELADO',   color: '#e53935', text: '#fff' },
};

export const ROLE_CONFIG = {
    DRIVER:     { label: 'Conductor',  color: 'primary' },
    ASSISTANT:  { label: 'Asistente',  color: 'info' },
    SUPERVISOR: { label: 'Supervisor', color: 'warning' }, // sólo por si acaso
};

export const PARADA_TIPO_CONFIG = {
    ORIGEN:     { label: 'Origen',     color: '#2e7d32', icon: '🚩' },
    INTERMEDIA: { label: 'Intermedia', color: '#1976d2', icon: '📍' },
    DESTINO:    { label: 'Destino',    color: '#c62828', icon: '🏁' },
};

export const END_REASON_LABELS = {
    ROLE_CHANGE:    'Cambio de rol',
    HANDOVER:       'Handover',
    TAKEOVER:       'Toma de control',
    SWAP:           'Intercambio',
    FORCED:         'Forzado',
    STALE:          'Inactivo (stale)',
    SESSION_CLOSE:  'Cierre de sesión',
    MANIFEST_CLOSE: 'Cierre de manifiesto',
    COMPLETED:      'Completado',
    COMPLETED_TRIP: 'Viaje completado',
};